import { getPlaylistAssignmentsUrl } from '../playlistAssignmentsUtils';
import { useFilteredPlaylistAssignmentsForPortal, usePlaylistAssignmentsParams } from '../playlistAssignmentsHooks';
import { useFilteredContentAssignmentsForPortal } from '../contentAssignmentsHooks';
import PlaylistAssignmentsBlankPage from './PlaylistAssignmentsBlankPage';
import PlaylistAssignmentsForPortalList from './PlaylistAssignmentsForPortalList';
import PlaylistAssignmentsForPortalTable from './PlaylistAssignmentsForPortalTable';
import PlaylistAssignmentsTablePage from './PlaylistAssignmentsTablePage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
import { usePortal } from '../../portals';
import { NavMarker } from 'react-rhumb';
import { AssignPlaylistButton } from 'academy-common-lib/features/playlistAssignments/components/AssignPlaylistButton';
import { ContentAssignButton } from 'academy-common-lib/features/contentAssignments/components/ContentAssignButton';
import { usePlaylist } from '../../savedItems/savedItemsQueries.migrated';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { ALL_CONTENT_PATH, ALL_PLAYLISTS_PATH } from '../../myTeam/constants/routes';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { useHasGate } from '../../accounts';
import { ASSIGN_ANY_CONTENT_GATE } from 'academy-common-lib/features/contentAssignments/contentAssignmentsConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsForPortalCount = ({
  count,
  total
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlistAssignments.assignmentsCount",
    options: {
      count,
      total
    }
  });
};
const PlaylistAssignmentsForPortal = ({
  playlistId: propPlaylistId,
  portalId: propPortalId,
  contentType
}) => {
  var _contentResult$conten;
  const {
    isMobile
  } = useMediaQuery();
  const {
    hasGate
  } = useHasGate(ASSIGN_ANY_CONTENT_GATE);
  const {
    portalId: paramPortalId,
    playlistId: paramPlaylistId
  } = usePlaylistAssignmentsParams();
  const portalId = propPortalId || paramPortalId;
  const playlistId = propPlaylistId || paramPlaylistId;
  const useContentFlow = !!contentType;
  const {
    playlist
  } = usePlaylist(playlistId || 0, !playlistId);
  const playlistName = (playlist === null || playlist === void 0 ? void 0 : playlist.name) || '';
  const {
    portal,
    portalLoading
  } = usePortal({
    portalId,
    skip: !portalId
  });
  const playlistResult = useFilteredPlaylistAssignmentsForPortal({
    playlistId,
    portalId
  });
  const contentResult = useFilteredContentAssignmentsForPortal({
    contentId: playlistId || 0,
    contentType: contentType || 'PLAYLIST',
    portalId: portalId || 0,
    skip: !useContentFlow
  });
  const total = useContentFlow ? contentResult.total : playlistResult.total;
  const loading = useContentFlow ? contentResult.contentAssignmentsForPortalLoading : playlistResult.playlistAssignmentsForPortalLoading;
  const query = useContentFlow ? contentResult.query : playlistResult.query;
  const assignments = useContentFlow ? (_contentResult$conten = contentResult.contentAssignmentsForPortal) === null || _contentResult$conten === void 0 ? void 0 : _contentResult$conten.map(a => Object.assign({}, a, {
    playlistId: a.contentId
  })) : playlistResult.playlistAssignmentsForPortal;
  const isLoading = portalLoading || loading;
  if (!portalId || !playlistId || isLoading) return null;
  if (!total && !(query !== null && query !== void 0 && query.length)) return /*#__PURE__*/_jsx(NavMarker, {
    name: "PLAYLIST_ASSIGNMENTS_LOADED",
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPage, {
      contentName: useContentFlow ? playlistName : undefined,
      contentType: contentType,
      playlistId: playlistId,
      portalId: portalId
    })
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PLAYLIST_ASSIGNMENTS_LOADED",
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
      actions: /*#__PURE__*/_jsxs(Flex, {
        gap: "300",
        overflow: "visible",
        children: [useContentFlow ? /*#__PURE__*/_jsx(ContentAssignButton, {
          contentId: playlistId,
          contentName: playlistName,
          contentType: contentType,
          portalId: portalId
        }) : /*#__PURE__*/_jsx(AssignPlaylistButton, {
          playlistId: playlistId,
          portalId: portalId
        }), /*#__PURE__*/_jsx(Button, {
          href: hasGate ? `/academy/${portalId}${ALL_CONTENT_PATH}?contentTypes=PLAYLIST%2CLEARNING_PATH` : `/academy/${portalId}${ALL_PLAYLISTS_PATH}`,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlistAssignments.viewAllPlaylistsMyTeam"
          })
        })]
      })
      // do not show back button if not using the routing
      ,
      backButton: paramPortalId ? {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.backLink"
        }),
        to: getPlaylistAssignmentsUrl(playlistId)
      } : undefined,
      headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.assignmentsForPortalHeader",
        options: {
          portalName: portal && portal.companyName || ''
        }
      }),
      searchFilter: FILTER_TYPES.SEARCH_USER,
      tableCount: assignments && total !== undefined && /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalCount, {
        count: assignments.length,
        total: total
      }),
      children: isMobile ? /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalList, {
        contentName: useContentFlow ? playlistName : undefined,
        contentType: contentType,
        playlistId: playlistId,
        portalId: portalId
      }) : /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalTable, {
        contentName: useContentFlow ? playlistName : undefined,
        contentType: contentType,
        playlistId: playlistId,
        portalId: portalId
      })
    })
  });
};
export default PlaylistAssignmentsForPortal;